import { createTheme, Theme, ThemeOptions } from '@mui/material'

export function getAppTheme (darkMode?: boolean): Theme {
  const lightTheme = {
    typography: {
      fontSize: 12,
    },
    overrides: {
      MuiAutocomplete: {
        option: {
          '&[data-focus="true"]': {
            color: '#003c55',
          },
        },
      },
      MuiOutlinedInput: {
        root: {
          '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
            border: '2px solid',
            borderColor: '#003c55',
          },
          '&$focused $notchedOutline': {
            borderColor: '#003c55',
            borderWidth: 1,
          },
        },
      },
      MuiTabs: {
        root: {
          backgroundColor: '#f5f5f5',
          borderTop: '2px solid',
          borderColor: '#ebe7e9',
        },
      },
      MuiTab: {
        root: {
          '&$selected': {
            backgroundColor: '#ffffff',
            borderTop: '3px solid',
            borderColor: '#003c55',
            color: '#003c55',
          },
        },
      },
      MuiButton: {
        root: {
          border: '1px solid #003c55',
          color: '#ffffff',
          backgroundColor: '#003c55',
          minWidth: '0',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#003c55',
            border: '1px solid #003c55',
          },
        },
        filledSecondary: {
          backgroundColor: '#4C4C4C',
          border: '1px solid #4C4C4C',
          '&:hover': {
            backgroundColor: '#003c55',
            border: '1px solid #003c55',
          },
        },
        filledPrimary: {
          color: '#ffffff',
          backgroundColor: '#003c55',
          border: '1px solid #003c55',
          '&:hover': {
            backgroundColor: '#003c55',
            border: '1px solid #003c55',
          },
        },
      },
      MuiPickersToolbarButton: {
        toolbarBtn: {
          border: 'none',
          '&:hover': {
            backgroundColor: 'transparent',
            border: 'none',
          },
        },
      },
      MuiPickersToolbarText: {
        toolbarTxt: {
          '&:hover': {
            color: '#003c55',
          },
        },
      },
    },
    palette: {
      primary: {
        main: '#003c55',
      },
      secondary: {
        main: '#4C4C4C',
      },
    },
  }

  const darkTheme: ThemeOptions = {
    typography: {
      fontSize: 12,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            border: '1px solid #00ffa3',
            minWidth: '0',
            boxShadow: 'none',
          },
          text: {
            color: '#00ffa3',
          },
        },
      },
    },
    palette: {
      mode: 'dark',
      primary: {
        main: '#00ffa3',
        light: 'rgba(255, 255, 255, 0.5)',
        dark: '#121212',
      },
      grey: {
        A100: 'transparent',
        A200: 'rgba(255, 255, 255, 0.08)',
      },
      secondary: {
        main: '#00ffa3',
      },
      background: {
        default: '#121212',
        paper: '#00ffa3',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.5)',
        secondary: 'rgba(255, 255, 255, 0.3)',
      },
    },
  }

  const theme: Theme = createTheme(darkMode ? darkTheme : lightTheme)

  return theme
}
